export default __webpack_public_path__ + "static/media/Mobile_login-pana.db8d5f0d.svg";